// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U3Hd","importantInfo":"styles_importantInfo__1KnEe"};